import { AfterViewChecked, Component, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, ViewEncapsulation, EventEmitter } from '@angular/core';
import Cleave from 'cleave.js';
import { Organization } from 'client/app/domains/Organization';
import { Batch } from 'client/app/domains/Batch';
import { DatePicker } from 'primeng/datepicker';
import { RetirementPlanDocumentsService } from '../service/retirement-plan-documents.service';
import { GemsService } from 'client/app/shared';
import { concatMap, tap } from 'rxjs/operators';
import { IUserProfile } from '@neb/lit-storybook';
import { each, filter, sortBy } from 'lodash';

@Component({
  selector: 'app-pending-acknowledgements',
  templateUrl: './pending-acknowledgements.component.html',
  styleUrls: ['./pending-acknowledgements.component.less'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class PendingAcknowledgementsComponent implements OnInit, OnChanges, AfterViewChecked, OnChanges {
  @Input() managedContent: any;
  @Output() docAcknowledgedEvent = new EventEmitter();

  @ViewChild('dateDistributedcalendar', { static: false })
  dateDistributedCalendar: DatePicker;

  dateDistributedCalendarCleave: any = null;

  organizations: Organization[];
  collectionsForSorting: any[] = [];
  isOpen: any[] = [];
  documentsLoading = true;

  baSubmitInstructions: string;
  radioButtonErrorMessage: string;

  TodaysDate: string;
  batch: Batch;
  distributionCount: number = 0;
  IsDatePickerOpen: boolean = false;
  SendDisabled: boolean = false;
  Disabled: boolean = false;
  English25PercentError = false;
  English500Error = false;
  English10PercentError = false;
  NonEnglishLanguageLesserErrorClass = '';
  NumParticipantsLesserErrorClass = '';
  NonEnglishLanguageMoreErrorClass = '';
  NumParticipantsMoreErrorClass = '';
  CommentsErrorClass = '';
  DistributionDateErrorClass = '';
  DistributionMethodErrorClass = '';
  MaxDateError = false;
  Errors = {};
  RetirementSpdIds: string;
  user: IUserProfile = null;

  maxDate: Date;

  constructor(
    private retirementPlanDocumentsService: RetirementPlanDocumentsService,
    private gemsService: GemsService
  ) { }

  ngOnInit(): void {
    this.loadData();
    this.setUser();
    this.maxDate = new Date();
  }

  ngOnCange(): void {
    console.log('in onChanges');
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && this.managedContent) {
      this.baSubmitInstructions = filter(this.managedContent.contents, { contentid: 'BA_Retirement_Submit_Instructions' })[0].content;
      this.radioButtonErrorMessage = filter(this.managedContent.contents, { contentid: 'BA_RadioButton_ErrorMessage' })[0].content;
    }
  }

  ngAfterViewChecked() {
    if (this.dateDistributedCalendar != undefined && this.dateDistributedCalendarCleave == null) {
      this.dateDistributedCalendarCleave = new Cleave(this.dateDistributedCalendar.inputfieldViewChild.nativeElement, {
        date: true,
        delimiter: '/',
        datePattern: ['m', 'd', 'Y']
      });
    }
  }

  setUser(): void {
    this.gemsService.getUser().pipe(
      tap(user => this.user = user)
    ).subscribe()
  }

  loadData() {
    this.gemsService.getUser().pipe(
      concatMap(user => this.retirementPlanDocumentsService.loadData(user.person_id))
    ).subscribe(
      (data: any) => {
        this.organizations = data.Organizations;
        for (let organization of data.Organizations) {
          const i = data.Organizations.indexOf(organization);
          this.collectionsForSorting["pendingsmmacknowledgements" + i] = sortBy(organization.PendingSmmAcknowledgements, ['PlanDocument']);
          this.collectionsForSorting["pendingspdacknowledgements" + i] = sortBy(organization.PendingSpdAcknowledgements, ['PlanDocument']);
          this.collectionsForSorting["pendingshacknowledgements" + i] = sortBy(organization.PendingShAcknowledgements, ['PlanDocument']);
          this.collectionsForSorting["pendingsmmacknowledgementssorted" + i] = sortBy(organization.PendingSmmAcknowledgements, ['PlanDocument']);
          this.collectionsForSorting["pendingspdacknowledgementssorted" + i] = sortBy(organization.PendingSpdAcknowledgements, ['PlanDocument']);
          this.collectionsForSorting["pendingshacknowledgementssorted" + i] = sortBy(organization.PendingShAcknowledgements, ['PlanDocument']);

          this.isOpen["pendingsmmacknowledgementssorted" + i] = false;
          this.isOpen["pendingspdacknowledgementssorted" + i] = false;
          this.isOpen["pendingspdsmmacknowledgementssorted" + i] = false;
          this.isOpen["pendingshacknowledgementssorted" + i] = false;
          this.distributionCount += (organization.PendingSmmAcknowledgements.length + organization.PendingSpdAcknowledgements.length + organization.PendingShAcknowledgements.length);
        }
        this.documentsLoading = false;
      });
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();

    this.TodaysDate = mm + '/' + dd + '/' + yyyy;
    this.batch = this.getNewBatch();

  }

  submitSpdSmmAcknowledgements(acknowledgementBatch) {

    this.retirementPlanDocumentsService.submitSpdSmmAcknowledgements(acknowledgementBatch).subscribe(
      (res: any) => {
        this.batch.Status = 'confirm';
      }

    )
  }

  submitSafeHarborAcknowledgements(acknowledgementBatch) {

    this.retirementPlanDocumentsService.submitSafeHarborAcknowledgements(acknowledgementBatch).subscribe(
      (res: any) => {
        this.batch.Status = 'confirm';
        each(this.organizations, function (organization) {
          organization.Status = 'Acknowledged';
        });
      }
    )
  }

  toggle(hidden) {
    this.isOpen[hidden] = !this.isOpen[hidden];
  }

  openPicker($event) {
    $event.preventDefault();
    $event.stopPropagation();

    this.IsDatePickerOpen = true;
  }

  participantsChanged() {
    this.batch.FewerThan100Participants = false;
    this.batch.MoreThan100Participants = false;
    const that = this;
    each(this.batch.SubmittedItems, function (submittedItem) {
      if (submittedItem.Participants < 0) {
        submittedItem.Participants = 0;
      }
      if (submittedItem.Participants < 100) {
        that.batch.FewerThan100Participants = true;
      }
      if (submittedItem.Participants >= 100) {
        that.batch.MoreThan100Participants = true;
      }
    });
  }

  send() {
    const that = this;
    this.validateForm(undefined, undefined);
    if (this.SendDisabled) {
      return false;
    }
    if (this.batch.SubmittedItems.length > 0) {
      if (this.batch.DocType === 'SPD' || this.batch.DocType === 'SMM') {
        this.batch.Status = 'preview';
      }
      else if (this.batch.DocType === 'SH') {
        this.batch.Status = 'preview';
        each(that.organizations, function (organization) {
          organization.Status = 'Sent';
        });
      }
    }
  }

  validateForm(inputName, clean) {
    this.SendDisabled = false;
    const that = this;
    if (!!clean) {
      this.English25PercentError = undefined;
      this.English500Error = undefined;
      this.English10PercentError = undefined;
      this.NonEnglishLanguageLesserErrorClass = '';
      this.NumParticipantsLesserErrorClass = '';
      this.NonEnglishLanguageMoreErrorClass = '';
      this.NumParticipantsMoreErrorClass = '';
      this.CommentsErrorClass = '';
      this.DistributionDateErrorClass = '';
      this.DistributionMethodErrorClass = '';
      this.MaxDateError = false;
      this.Errors = {};
      return;
    }

    function shouldValidate(validationInputName) {
      if (inputName === undefined || inputName.indexOf(validationInputName) >= 0) {
        return true;
      }
      else {
        return false;
      }
    }

    var today = new Date();
    var distributionDate = new Date(this.batch.DistributionDate);
    if (distributionDate.getFullYear() < 1000) {
      this.batch.DistributionDate.setFullYear(today.getFullYear());
    }

    each(that.batch.SubmittedItems, function (submittedItem) {
      var itemInputName = 'Participants' + submittedItem.Id;
      if (shouldValidate(itemInputName) && submittedItem.DocType !== 'SH') {
        if (submittedItem.Participants === undefined || submittedItem.Participants === null) {
          submittedItem.ErrorClass = 'form-item-error';
          that.Errors[itemInputName] = true;
        }
        else {
          submittedItem.ErrorClass = '';
          that.Errors[itemInputName] = false;
        }
      }
    });

    if (this.batch.English25Percent !== undefined) {
      this.English25PercentError = false;
      this.Errors['English25Percent'] = false;


      if (shouldValidate('NonEnglishLanguageLesser')) {
        if (this.batch.NonEnglishLanguageLesser === '' && this.batch.English25Percent === true) {
          this.NonEnglishLanguageLesserErrorClass = 'form-item-error';
          this.Errors['NonEnglishLanguageLesser'] = true;
        }
        else {
          this.NonEnglishLanguageLesserErrorClass = '';
          this.Errors['NonEnglishLanguageLesser'] = false;
        }
      }
      if (shouldValidate('NumParticipantsLesser') && this.batch.English25Percent === true) {
        if (this.batch.NumParticipantsLesser == null) {
          this.NumParticipantsLesserErrorClass = 'form-item-error';
          this.Errors['NumParticipantsLesser'] = true;
        }
        else {
          this.NumParticipantsLesserErrorClass = '';
          this.Errors['NumParticipantsLesser'] = false;
        }
      }
    }
    else {
      this.NonEnglishLanguageLesserErrorClass = '';
      this.Errors['NonEnglishLanguageLesser'] = false;
      this.NumParticipantsLesserErrorClass = '';
      this.Errors['NumParticipantsLesser'] = false;

      if (shouldValidate('English25Percent')) {
        if (this.batch.English25Percent === undefined && this.batch.FewerThan100Participants) {
          this.English25PercentError = true;
          this.Errors['English25Percent'] = true;
        } else {
          this.English25PercentError = false;
          this.Errors['English25Percent'] = false;
        }
      }
    }

    if (shouldValidate('English500')) {
      if (this.batch.English500 === undefined && this.batch.MoreThan100Participants) {
        this.English500Error = true;
        this.Errors['English500'] = true;
      }
      else {
        this.English500Error = false;
        this.Errors['English500'] = false;
      }
    }

    if (this.batch.English500 !== undefined) {
      this.English500Error = false;
      this.Errors['English500'] = false;

      if (shouldValidate('English10Percent')) {
        if (this.batch.English10Percent === undefined && this.batch.English500 === true) {
          this.English10PercentError = true;
          this.Errors['English10Percent'] = true;
        }
        else {
          this.English10PercentError = false;
          this.Errors['English10Percent'] = false;
        }
      }

      if (shouldValidate('NonEnglishLanguageMore')) {
        if (this.batch.NonEnglishLanguageMore === '' && this.batch.English500 === true) {
          this.NonEnglishLanguageMoreErrorClass = 'form-item-error';
          this.Errors['NonEnglishLanguageMore'] = true;
        }
        else {
          this.NonEnglishLanguageMoreErrorClass = '';
          this.Errors['NonEnglishLanguageMore'] = false;
        }
      }

      if (shouldValidate('NumParticipantsMore')) {
        if (this.batch.NumParticipantsMore == null && this.batch.English500 === true) {
          this.NumParticipantsMoreErrorClass = 'form-item-error';
          this.Errors['NumParticipantsMore'] = true;
        }
        else {
          this.NumParticipantsMoreErrorClass = '';
          this.Errors['NumParticipantsMore'] = false;
        }
      }
    }
    else {
      this.NumParticipantsMoreErrorClass = '';
      this.Errors['NumParticipantsMore'] = false;
      this.NonEnglishLanguageMoreErrorClass = '';
      this.Errors['NonEnglishLanguageMore'] = false;
      this.English10PercentError = false;
      this.Errors['English10Percent'] = false;
    }

    if (shouldValidate('DistributionDate')) {
      if (distributionDate.getFullYear() > today.getFullYear() ||
        (distributionDate.getFullYear() === today.getFullYear() &&
          distributionDate.getMonth() > today.getMonth()) ||
        (
          distributionDate.getFullYear() === today.getFullYear() &&
          distributionDate.getMonth() === today.getMonth() &&
          distributionDate.getDate() > today.getDate()
        )
      ) {
        this.MaxDateError = true;
        this.Errors['DistributionDateMaxDate'] = true;
      }
      else {
        this.MaxDateError = false;
        this.Errors['DistributionDateMaxDate'] = false;
      }

      if (this.batch.DistributionDate === undefined || this.batch.DistributionDate == null || distributionDate.getFullYear() < 1000) {
        this.DistributionDateErrorClass = 'form-item-error';
        this.Errors['DistributionDateRequired'] = true;
      }
      else {
        this.DistributionDateErrorClass = '';
        this.Errors['DistributionDateRequired'] = false;
      }
    }

    if ((shouldValidate('DistributionMethod') || shouldValidate('Comments'))) {
      if ((this.batch.DistributionMethod === 'Other (Specify in Comments)' ||
        this.batch.DistributionMethod === 'Multiple Methods (Specify in Comments)') && this.batch.Comments === '') {
        this.CommentsErrorClass = 'form-item-error';
        this.Errors['Comments'] = true;
      }
      else {
        this.CommentsErrorClass = '';
        this.Errors['Comments'] = false;
      }

      if (this.batch.DistributionMethod === '- Select -') {
        this.DistributionMethodErrorClass = 'form-item-error';
        this.Errors['DistirbutionMethod'] = true;
      }
      else {
        this.DistributionMethodErrorClass = '';
        this.Errors['DistirbutionMethod'] = false;
      }
    }

    for (var key in this.Errors) {
      if (this.Errors.hasOwnProperty(key) && this.Errors[key] === true) {
        this.SendDisabled = true;
        break;
      }
    }
  }

  sortDataPendingAcknowledgements(sorting: Sort, i: number) {
    const dataSpd = this.collectionsForSorting["pendingspdacknowledgements" + i].slice();
    const dataSmm = this.collectionsForSorting["pendingsmmacknowledgements" + i].slice();
    const dataSh = this.collectionsForSorting["pendingshacknowledgements" + i].slice();
    if (!sorting.active || sorting.direction === '') {
      this.collectionsForSorting["pendingspdacknowledgementssorted" + i] = dataSpd.slice();
      this.collectionsForSorting["pendingsmmacknowledgementssorted" + i] = dataSmm.slice();
      this.collectionsForSorting["pendingshacknowledgementssorted" + i] = dataSh.slice();
      return;
    }

    this.collectionsForSorting["pendingspdacknowledgementssorted" + i] = dataSpd.sort((a, b) => {
      const isAsc = sorting.direction === 'asc';
      switch (sorting.active) {
        case 'PlanDocument': return compare(a.PlanDocument, b.PlanDocument, isAsc);
        case 'EffectiveDateDisplay': return compare(a.EffectiveDate, b.EffectiveDate, isAsc);
        default: return 0;
      }
    });

    this.collectionsForSorting["pendingsmmacknowledgementssorted" + i] = dataSmm.sort((a, b) => {
      const isAsc = sorting.direction === 'asc';
      switch (sorting.active) {
        case 'PlanDocument': return compare(a.PlanDocument, b.PlanDocument, isAsc);
        case 'EffectiveDateDisplay': return compare(a.EffectiveDate, b.EffectiveDate, isAsc);
        default: return 0;
      }
    });

    this.collectionsForSorting["pendingshacknowledgementssorted" + i] = dataSh.sort((a, b) => {
      const isAsc = sorting.direction === 'asc';
      switch (sorting.active) {
        case 'PlanDocument': return compare(a.PlanDocument, b.PlanDocument, isAsc);
        case 'EffectiveDateDisplay': return compare(a.EffectiveDate, b.EffectiveDate, isAsc);
        default: return 0;
      }
    });
  }

  checkStart(documentType) {
    const that = this;
    each(this.organizations, function (item, index) {

      if (documentType === 'SPD') {
        item.SpdStartEnabled = false;
        item.SpdMaster = true;
        item.SmmMaster = true;

        each(that.collectionsForSorting["pendingspdacknowledgementssorted" + index], function (spd) {
          //each(distribution.documents.spds, function (spd) {
          if (spd.Checked) {
            item.SpdStartEnabled = true;
          }
          else {
            item.SpdMaster = false;
          }
        });
        each(that.collectionsForSorting["pendingsmmacknowledgementssorted" + index], function (smm) {
          //each(distribution.documents.spds, function (spd) {
          if (smm.Checked) {
            item.SpdStartEnabled = true;
          }
          else {
            item.SmmMaster = false;
          }
        });
      }

      if (documentType === 'SMM') {
        item.SmmStartEnabled = false;
        //item.SpdStartEnabled = false;
        item.SmmMaster = true;
        item.SpdMaster = true;
        item.SpdStartEnabled = false;

        each(that.collectionsForSorting["pendingsmmacknowledgementssorted" + index], function (smm) {
          //each(distribution.documents.spds, function (spd) {
          if (smm.Checked) {
            item.SmmStartEnabled = true;
            //item.SpdStartEnabled = true;
          }
          else {
            item.SmmMaster = false;
          }
        });
        each(that.collectionsForSorting["pendingspdacknowledgementssorted" + index], function (spd) {
          //each(distribution.documents.spds, function (spd) {
          if (spd.Checked) {
            item.SpdStartEnabled = true;
          }
          else {
            item.SpdMaster = false;
          }
        });
      }
    });
  }

  getEdited(document, org) {
    return {
      Organization: org,
      PlanDocument: document.PlanDocument,
      Id: document.Id,
      DocType: document.Type,
      DownloadLink: document.DownloadLink,
      Participants: null,
      ErrorClass: '',
    };
  }

  start(docType, org) {
    this.batch = this.getNewBatch();
    this.batch.Ids = [];
    const that = this;
    each(this.organizations, function (organization, index) {
      if (organization.Name === org) {
        if (docType === 'SPD') {
          that.batch.Status = 'edit';
          each(that.collectionsForSorting["pendingspdacknowledgementssorted" + index], function (document) {
            if (document.Checked) {
              var submitted = that.getEdited(document, org);
              that.batch.Ids.push(submitted.Id);
              that.batch.SubmittedItems.push(submitted);
              that.batch.DocType = docType;
              that.batch.DocTypeDisplay = docType + '(s)';
              that.batch.HasSpds = true;
            }
          });
          each(that.collectionsForSorting["pendingsmmacknowledgementssorted" + index], function (document) {
            if (document.Checked) {
              var submitted = that.getEdited(document, org);
              that.batch.Ids.push(submitted.Id);
              that.batch.SubmittedItems.push(submitted);
              that.batch.DocType = docType;
              if (that.batch.DocTypeDisplay.indexOf('SMM(s)') < 0)
                that.batch.DocTypeDisplay = that.batch.DocTypeDisplay === '' ? 'SMM(s)' : 'SPD(s)/SMM(s)';
              that.batch.HasSmms = true;
            }
          });
        }
        if (docType === 'SMM') {
          that.batch.Status = 'edit';
          each(that.collectionsForSorting["pendingsmmacknowledgementssorted" + index], function (document) {
            if (document.Checked) {
              var submitted = that.getEdited(document, org);
              that.batch.Ids.push(submitted.Id);
              that.batch.SubmittedItems.push(submitted);
              that.batch.DocType = docType;
              if (that.batch.DocTypeDisplay.indexOf('SMM(s)') < 0)
                that.batch.DocTypeDisplay = that.batch.DocTypeDisplay === '' ? 'SMM(s)' : 'SPD(s)/SMM(s)';
              that.batch.HasSmms = true;
            }
          });
        }
        if (docType === 'SH') {
          that.batch.Status = 'edit';

          // each(that.organizations, function (o, i) {
          //   if (o.Name !== organization.Name) {
          //     //o.PendingShAcknowledgements.Open = false;
          //     that.isOpen["pendingshacknowledgementssorted" + i] = false;
          //   }
          //   o.Expanded = false;
          //   //that.collectionsForSorting['pendingshacknowledgementssorted' + i].Status = '';
          //   o.Status = '';
          // });

          //organization.Expanded = true;
          //that.collectionsForSorting['pendingshacknowledgementssorted' + index].Status = '';

          organization.Status = '';
          each(that.collectionsForSorting["pendingshacknowledgementssorted" + index], function (document) {
            var submitted = that.getEdited(document, org);
            that.batch.Ids.push(submitted.Id);
            that.batch.SubmittedItems.push(submitted);
            that.batch.DocType = docType;
            that.batch.HasSh = true;
          });
          setTimeout(function () {
            that.isOpen["pendingshacknowledgementssorted" + index] = true;
          }, 0);

          that.batch.ShEffectiveDate = that.collectionsForSorting["pendingshacknowledgementssorted" + index][0].EffectiveDate;

          //organization.PendingShAcknowledgements.Open = true;
        }
      }
    });
    //init form value
    this.batch.DistributionMethod = '- Select -';
    this.RetirementSpdIds = this.batch.Ids.join(',');

  }

  getNewBatch() {
    return {
      Ids: [],
      DocType: undefined,
      DocTypeDisplay: '',
      Status: undefined,
      FewerThan100Participants: undefined,
      English25Percent: undefined,
      LessTotalNumber: undefined,
      NumParticipantsLesser: null,
      NonEnglishLanguageLesser: '',
      MoreThan100Participants: undefined,
      English500: undefined,
      English10Percent: undefined,
      NumParticipantsMore: null,
      NonEnglishLanguageMore: '',
      DistributionDate: undefined,
      DistributionMethod: undefined,
      Comments: '',
      SubmittedItems: [],
      HasSpds: undefined,
      HasSmms: undefined,
      HasSh: undefined,
      PersonId: undefined,
      Attestation: undefined,
      SaveActionCompleted: false,
      AttestationNotChecked: false,
      VerifiedNumParticipants: undefined,
      VerifiedNumParticipantsNotChecked: false
    };
  }

  edit() {
    if (this.batch.DocType === 'SPD' || this.batch.DocType === 'SMM') {
      this.batch.Status = 'edit';
    }
    else if (this.batch.DocType === 'SH') {
      this.batch.Status = 'edit';
      each(this.organizations, function (organization) {
        organization.Status = '';
      });
    }
  }

  reset() {
    this.validateForm(null, true);
    this.batch = this.getNewBatch();

    const that = this;
    each(that.organizations, function (organization, i) {
      organization.Expanded = false;
      organization.Status = '';
      that.isOpen['pendingspdacknowledgementssorted' + i] = false;
      that.isOpen['pendingsmmacknowledgementssorted' + i] = false;
      that.isOpen['pendingspdsmmacknowledgementssorted' + i] = false;
      that.isOpen['pendingshacknowledgementssorted' + i] = false;

      each(that.collectionsForSorting["pendingspdacknowledgementssorted" + i], function (spd) {
        spd.Checked = true;
      });
      each(that.collectionsForSorting["pendingsmmacknowledgementssorted" + i], function (spd) {
        spd.Checked = true;
      });
    });

    this.checkStart('SPD');
    this.checkStart('SMM')

    this.dateDistributedCalendarCleave = null;
  }

  submit(invalid) {
    var attestationChecked = this.batch.Attestation;
    var verifiedNumParticipantsChecked = this.batch.VerifiedNumParticipants;
    var validationChecked = true;

    if (!attestationChecked) {
      this.batch.AttestationNotChecked = true;
      validationChecked = false;
    }
    //SafeHarbor doesn't have this check, so only validate for this for SPD or SMM doc types
    if (this.batch.DocType === 'SPD' || this.batch.DocType === 'SMM') {
      if (!verifiedNumParticipantsChecked) {
        this.batch.VerifiedNumParticipantsNotChecked = true;
        validationChecked = false;
      }
    }
    if (!validationChecked) {
      return false;
    }

    if (!invalid) {
      if (this.batch.DocType === 'SPD' || this.batch.DocType === 'SMM') {
        var i;
        var spdSubmittedItems = [];
        var smmSubmittedItems = [];
        this.batch.Ids = [];
        for (i = 0; i < this.batch.SubmittedItems.length; i++) {
          this.batch.Ids.push(this.batch.SubmittedItems[i].Id);
          if (this.batch.SubmittedItems[i].DocType === 'SPD')
            spdSubmittedItems.push(
              {
                RetId: this.batch.SubmittedItems[i].Id,
                ParticipantCount: this.batch.SubmittedItems[i].Participants,
              });
          if (this.batch.SubmittedItems[i].DocType === 'SMM')
            smmSubmittedItems.push(
              {
                RetId: this.batch.SubmittedItems[i].Id,
                ParticipantCount: this.batch.SubmittedItems[i].Participants,
              });
        }

        this.batch.Ids = this.batch.Ids.slice(0, -1);

        const acknowledgementBatch = {
          Can25PercentRead: this.batch.English25Percent,
          NumberWhoReadSmallPlan: this.batch.NumParticipantsLesser,
          LanguageForSmallPlan: this.batch.NonEnglishLanguageLesser,
          Can500Read: this.batch.English500,
          Can10PercentRead: this.batch.English10Percent,
          NumberWhoReadLargePlan: this.batch.NumParticipantsMore,
          LanguageForLargePlan: this.batch.NonEnglishLanguageMore,
          MethodOfDelivery: this.batch.DistributionMethod,
          Comments: this.batch.Comments,
          DistributionDate: this.batch.DistributionDate,
          FirstName: this.user.first_name,
          LastName: this.user.last_name,
          SubmittedBy: '',//we don't have CID in LUX2, adding personId instead
          SpdsForSubmission: spdSubmittedItems,
          SmmsForSubmission: smmSubmittedItems,
          PersonId: this.user.person_id,
          AttestationChecked: this.batch.Attestation,
          VerifiedNumParticipantsChecked: this.batch.VerifiedNumParticipants
        };
        this.batch.Status = 'confirm';
        this.submitSpdSmmAcknowledgements(acknowledgementBatch);

        this.docAcknowledgedEvent.emit(this.batch.DocType);
        this.batch.SaveActionCompleted = true;
        return true;
      }
      else if (this.batch.DocType === 'SH') {
        this.batch.Ids = [this.batch.SubmittedItems[0].Id];
        const acknowledgment = {
          DocumentId: this.batch.SubmittedItems[0].Id,
          Comments: this.batch.Comments,
          DistributionDate: this.batch.DistributionDate,
          MethodOfDelivery: this.batch.DistributionMethod,
          FirstName: this.user.first_name,
          LastName: this.user.last_name,
          SubmittedBy: '',
          PersonId: this.user.person_id,
          AttestationChecked: this.batch.Attestation,
          verifiedNumParticipantsChecked: this.batch.VerifiedNumParticipants
        };

        this.batch.Status = 'confirm';

        this.submitSafeHarborAcknowledgements(acknowledgment);

        this.docAcknowledgedEvent.emit(this.batch.DocType);
      }
    }

    this.dateDistributedCalendarCleave = null;
  }

  closeOthers(index, closeAll) {
    const that = this;
    each(this.organizations, function (organization, loopIndex) {
      const i = loopIndex;
      that.isOpen["pendingspdacknowledgementssorted" + i] = false;
      that.isOpen["pendingshacknowledgementssorted" + i] = false;
      that.isOpen["pendingsmmacknowledgementssorted" + i] = false;
      that.isOpen["pendingspdsmmacknowledgementssorted" + i] = false;
    });
    this.isOpen["pendingspdacknowledgementssorted" + index] = closeAll;
    this.isOpen["pendingshacknowledgementssorted" + index] = closeAll;
    this.isOpen["pendingsmmacknowledgementssorted" + index] = closeAll;
    this.isOpen["pendingspdsmmacknowledgementssorted" + index] = closeAll;

  }

  closeConfirm() {
    this.batch = this.getNewBatch();
    each(this.organizations, function (organization) {
      organization.Expanded = false;
      organization.Status = '';
    });
    this.documentsLoading = true;
    this.organizations = [];
    this.loadData();
  }

  toggleSelection(documentType) {
    const that = this;
    each(this.organizations, function (item, index) {
      if (documentType === 'SPD') {
        each(that.collectionsForSorting["pendingspdacknowledgementssorted" + index], function (spd) {
          spd.Checked = item.SpdMaster;
        });
      }
      if (documentType === 'SMM') {
        each(that.collectionsForSorting["pendingsmmacknowledgementssorted" + index], function (smm) {
          smm.Checked = item.SmmMaster;
        });
      }
    });
    this.checkStart(documentType);
  }
}

function compare(a: number | string | Date, b: number | string | Date, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

export class Sort {
  public direction: string;
  public active: string;
}

